export default __webpack_public_path__ + "static/media/google-play-store.91294c09.png";